import { render, staticRenderFns } from "./ProductsInfo.vue?vue&type=template&id=0ada3a63&scoped=true"
import script from "./ProductsInfo.vue?vue&type=script&lang=js"
export * from "./ProductsInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductsInfo.vue?vue&type=style&index=0&id=0ada3a63&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada3a63",
  null
  
)

export default component.exports